<template>
  <el-popover
      placement="top-start"
      title=""
      width="440"
      trigger="hover">
      <div class="four-people-popover">
        <div class="title">4人以上预订方式：</div>
        <div class="content">可先填入4人信息锁定舱房，在完成预订后致电客服添加剩余乘客并补齐差价。请注意预订显示价格为当前选择人数价格，最终支付价格以实际入住人数为准。</div>
      </div>
      <span class="four-people-text" slot="reference">
          <span>超过4人预订</span>
          <img class="det_icon" src="https://resource.rcclchina.com.cn/tui2/info/tips.png"/>
      </span>
  </el-popover>
</template>

<script>
export default {
  name: "FourPeopleBookingTag",
  props: {
  },
  computed: {
  }
}
</script>

<style lang="less" scoped>
.four-people-text {
  margin-left: 20px;
  margin-top: -5px;
  display: inline-block;
  height: 16px;
  color: #2c77d1;
  cursor: pointer;
  vertical-align: middle;
  & > span {
    display: inline-block;
    height: 16px;
    margin-right: 3px;
  }
}
.four-people-popover {
  & .title {
    font-size: 14px;
    font-weight: bold;
    color: #2c77d1;
  }
  & .content {
    margin-top: 5px;
    font-size: 13px;
    color: #333333;
  }
}
</style>

<style lang="less">
.nrp-dot-tag {
  .arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }
  .tooltip.bs-tooltip-right {
    padding: 0 5px;
    margin-left: 3px;
    .arrow {
      top: 50%;
      left: 0;
      margin-top: -5px;
      border-width: 5px 5px 5px 0;
      border-right-color: #fff;
    }
  }
}
.el-popper[x-placement^=top]{
  margin-bottom: 20px !important;
}
.el-popper[x-placement^=top] .popper__arrow {
  bottom: -16px;
}
.el-popper .popper__arrow {
  border-width: 15px;
}
.el-popper[x-placement^=top] .popper__arrow::after {
  bottom: 2px;
  margin-left: -15px;
}
.el-popper .popper__arrow::after {
  content: " ";
  border-width: 15px;
}

.el-popper[x-placement^=bottom]{
  margin-top: 20px !important;
}
.el-popper[x-placement^=bottom] .popper__arrow {
  top: -16px;
}
.el-popper .popper__arrow {
  border-width: 15px;
}
.el-popper[x-placement^=bottom] .popper__arrow::after {
  top: 2px;
  margin-left: -15px;
}
.el-popper .popper__arrow::after {
  content: " ";
  border-width: 15px;
}
</style>